import script from "./ChatMessageInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageInput.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QUploaderAddTrigger from 'quasar/src/components/uploader/QUploaderAddTrigger.js';
import qInstall from "../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QUploaderAddTrigger});
